import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import { TextButton } from '@modules/shortlist/index.styles'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'

import { DeleteAlertsButtonProps } from '../types'

export const DeleteAlertsButton = ({ isDisabled, onClick }: DeleteAlertsButtonProps) => {
  const { t } = useTranslation()
  return (
    <TextButton
      variant="text"
      color="primary"
      endIcon={<DeleteOutlineOutlinedIcon color="inherit" fontSize="small" sx={{ marginLeft: '-6px' }} />}
      onClick={onClick}
      disabled={isDisabled}
      id="alert-delete_alerts"
    >
      {t(translationKeys.DELETE_ALERTS_SHORTLIST)}
    </TextButton>
  )
}
